import Model from './Model';

export default class StudyLevel extends Model {
    name;

    static apiPath() {
        return 'studies';
    }
}



// WEBPACK FOOTER //
// ./src/models/StudyOption.js